import { Route, Switch, Redirect } from "react-router-dom";
import { AppRoutes, UserRoutes } from "constants/routes";
import UserListPage from "./UserListPage";
import UserPage from "./UserPage";

const UserRouter = () => (
  <Switch>
    <Route exact path={AppRoutes.Users} component={UserListPage} />
    <Route path={UserRoutes.User()} component={UserPage} />
    <Route render={() => <Redirect to={AppRoutes.Users} />} />
  </Switch>
);

export default UserRouter;
